import { TextLink } from '@oneaudi/unified-web-components';
import React, { useContext } from 'react';
import { useMediaQuery } from '@oneaudi/feature-app-utils';
import { Context } from '../../../context/Context';
import { useTrackingManager } from '../../../utils/useTrackingManager';
import VtpHeadline from './VtpHeadline';
import { VtpContainer } from '../SubPageNavigationStyles';

const VtpLinks = () => {
  const { vtpData } = useContext(Context);
  const { newCarsText, usedCarsText, newCarsAmount, newCarsUrl, usedCarsAmount, usedCarsUrl } =
    vtpData;
  const { click } = useTrackingManager();
  const lgScreenSize = useMediaQuery('(min-width: 1024px)');
  const textLinkSize: 'sm' | 'md' = process.env.IS_LEGACY && lgScreenSize ? 'md' : 'sm';

  return (
    <VtpContainer role="group">
      <VtpHeadline />
      {newCarsAmount !== 0 && newCarsUrl !== '' && (
        <TextLink
          size={textLinkSize}
          variant="standalone"
          href={newCarsUrl}
          onClick={() =>
            click(
              'link',
              true,
              newCarsText.replace(/\s?\(\d+\)/g, ''),
              newCarsUrl,
              `${newCarsAmount}`,
              'secondary',
            )
          }
          role="menuitem"
        >
          {newCarsText}
        </TextLink>
      )}
      {usedCarsAmount !== 0 && usedCarsUrl !== '' && (
        <TextLink
          size={textLinkSize}
          variant="standalone"
          href={usedCarsUrl}
          onClick={() =>
            click(
              'link',
              true,
              usedCarsText.replace(/\s?\(\d+\)/g, ''),
              usedCarsUrl,
              `${usedCarsAmount}`,
              'secondary',
            )
          }
          role="menuitem"
        >
          {usedCarsText}
        </TextLink>
      )}
    </VtpContainer>
  );
};

export default VtpLinks;
